import applyBone from "./apply-bone";

const vector = new THREE.Vector3();

function generateAnimatedBoundingBox(object) {
    object.traverse(object => {
        if (!object.isSkinnedMesh) return;

        /**
         * @type {THREE.BufferGeometry}
         */
        const geometry = object.geometry;

        if (!geometry.isBufferGeometry) return;

        const attrSkinIndex = geometry.getAttribute("skinIndex");
        const attrSkinWeight = geometry.getAttribute("skinWeight");
        const attrPosition = geometry.getAttribute("position");

        if (!attrSkinIndex || !attrSkinWeight || !attrPosition) return;

        const boundingBox = new THREE.Box3();
        const boneMatrices = object.skeleton.boneMatrices;
        const bindMatrix = object.bindMatrix;
        const bindMatrixInverse = object.bindMatrixInverse;

        for (let index = 0; index < attrPosition.count; index++) {
            boundingBox.expandByPoint(applyBone({
                vector: vector.fromBufferAttribute(attrPosition, index),
                attrSkinIndex,
                attrSkinWeight,
                bindMatrix,
                bindMatrixInverse,
                boneMatrices,
                index
            }));
        }

        geometry.boundingBoxAnimated = boundingBox;
    });
}

export default generateAnimatedBoundingBox;
export { generateAnimatedBoundingBox };